import { colors, Link, Message, Paragraph } from 'component-library';
import { Trans, useTranslation } from 'react-i18next';
import { useCompanies } from '../../hooks/useCompanies';

type ConfidentialGracefulDegradationProps = {
  mt?: string;
  mb?: string;
};

export const ConfidentialGracefulDegradation = ({
  mt,
  mb,
}: ConfidentialGracefulDegradationProps) => {
  const { supportedCompanies } = useCompanies();

  const { t } = useTranslation();

  if (!supportedCompanies.confidential.hasAccess) {
    return null;
  }

  return (
    <Message
      title={t('confidential.graceful-degradation.title')}
      severity="info"
      mt={mt}
      mb={mb}
      closable={true}
      closedStorageKey="confidential-graceful-degradation"
    >
      <Paragraph variant="large" mb="xxsmall">
        {t('confidential.graceful-degradation.description')}
      </Paragraph>
      <Paragraph variant="large">
        <Trans
          i18nKey="confidential.graceful-degradation.description2"
          components={{
            MailTo: (
              <Link
                href={`mailto:kundservice@stenaconfidential.se`}
                inline={true}
                color={colors.base.black}
                underline={true}
              />
            ),
          }}
        />
      </Paragraph>
    </Message>
  );
};
